import dayjs from "dayjs";

export const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });

export const compact = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e9) return `${(v / 1e9).toFixed(v % 1e9 === 0 ? 0 : 2)}B`;
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(v % 1e6 === 0 ? 0 : 2)}M`;
  if (Math.abs(v) >= 1e4) return `${(v / 1e3).toFixed(1)}K`;
  return fmt(v);
};

export const pct = (part, whole) => (whole > 0 ? Math.round((part / whole) * 1000) / 10 : 0);

export const dateTime = (iso) => (iso ? dayjs(iso).format("MMM D, YYYY · h:mm A") : "—");
export const dateOnly = (iso) => (iso ? dayjs(iso).format("MMM D, YYYY") : "—");

// Date-range presets shared by every analytics screen.
export const RANGE_PRESETS = [
  { key: "all", label: "All time", range: () => ({ from: "", to: "" }) },
  { key: "today", label: "Today", range: () => ({ from: dayjs().format("YYYY-MM-DD"), to: dayjs().format("YYYY-MM-DD") }) },
  { key: "7d", label: "7 days", range: () => ({ from: dayjs().subtract(6, "day").format("YYYY-MM-DD"), to: dayjs().format("YYYY-MM-DD") }) },
  { key: "30d", label: "30 days", range: () => ({ from: dayjs().subtract(29, "day").format("YYYY-MM-DD"), to: dayjs().format("YYYY-MM-DD") }) },
  { key: "month", label: "This month", range: () => ({ from: dayjs().startOf("month").format("YYYY-MM-DD"), to: dayjs().format("YYYY-MM-DD") }) },
  { key: "year", label: "This year", range: () => ({ from: dayjs().startOf("year").format("YYYY-MM-DD"), to: dayjs().format("YYYY-MM-DD") }) },
];

export const REASON_LABELS = {
  admin_credit: "Admin added",
  admin_debit: "Admin subtracted",
  gift_category_share: "Gift share",
  pending_release: "Pending released (goal reached)",
  category_send_coins: "Category transfer",
};

export const CYCLE_STATUS = {
  running: { label: "Running", cls: "rv-badge-violet" },
  achieved: { label: "Goal reached", cls: "rv-badge-green" },
  completed: { label: "Completed", cls: "rv-badge-green" },
  expired: { label: "Expired", cls: "rv-badge-red" },
  stopped: { label: "Stopped", cls: "rv-badge-red" },
};

// The category's clock (category_targets.run_status).
export const RUN_STATUS = {
  running: { label: "Running", cls: "rv-badge-green", dot: "#01b574" },
  paused: { label: "Paused", cls: "rv-badge-gold", dot: "#f4d134" },
  stopped: { label: "Stopped", cls: "rv-badge-grey", dot: "#a0aec0" },
};

export const RUN_ACTION_LABELS = {
  start: "Started",
  pause: "Paused",
  resume: "Resumed",
  stop: "Stopped",
  rollover: "New month started",
  default_on: "Marked as default",
  default_off: "Default removed",
};

/// 3d 4h · 4h 12m · 12m 5s — for countdowns.
export const duration = (seconds) => {
  let s = Math.max(0, Math.floor(Number(seconds) || 0));
  const d = Math.floor(s / 86400);
  s -= d * 86400;
  const h = Math.floor(s / 3600);
  s -= h * 3600;
  const m = Math.floor(s / 60);
  const sec = s - m * 60;
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m ${sec}s`;
};

export const imgOr = (resolveImg, img) => (img ? resolveImg(img) : null);
